// extracted by mini-css-extract-plugin
export default {"sessionEmailExpiredPageWrapper":"styles_sessionEmailExpiredPageWrapper__phfLp","pageContent":"styles_pageContent__mS4Vh","textBlock":"styles_textBlock__B6AOy"};